// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBars_container__3rSsq","title":"ProgressBars_title__3VQ10"};